import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadVODPlayer } from '@wix/wix-vod-shared/src/widget/utils/load-player';
import i18n from '@wix/wix-vod-shared/src/common/i18n';
import CardsModule from '@wix/video-player/video-player-cards/src';
import getPlayerTranslations from 'shared/utils/get-player-translations';
import { makeCancelable } from 'shared/utils/promise';
import getVidiUrls from 'shared/selectors/vidi-urls';
import { getVideoCardsList } from 'widget/selectors/video-cards';
import { getOwnershipStatus } from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';
import VideoCardsWrapper from './components/video-cards-wrapper-desktop/video-cards-wrapper-desktop';
import VideoCards from '@wix/wix-vod-shared/src/widget/vod-player/components/video-cards/video-cards';
import AllVideoCards from '@wix/wix-vod-shared/src/widget/vod-player/components/video-cards/all-cards/all-cards';
import ShareOverlay from 'widget/containers/share-overlay/share-overlay';
import getBuyClickHandler from 'widget/utils/get-buy-click-handler';
import { isInFullScreen, isPlayerUIVisible } from 'shared/selectors/player';
import { isShareOverlayOpen } from 'widget/selectors/share-overlay';
import LiveVideoUpdaters from './containers/live-video-updaters/live-video-updaters';

import { isPreviewOrEditorMode, openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';
import Spinner from '@wix/wix-vod-shared/src/widget/ui-components/loading-spinner/loading-spinner';
import { toggleShareVideoOverlay } from 'widget/redux/client/actions/share-overlay';
import { showPlayerUI, hidePlayerUI } from 'widget/redux/client/actions/player/ui';

import progressBarStyles from './components/progress-bar.styl';
import { getBuyRentTextForPlayer } from 'shared/utils/buy-button-texts/buy-button-texts';
import { playVideo, pauseVideo } from 'widget/redux/client/actions/player/change-playback-status';

import { areElementsRounded } from 'shared/selectors/app-settings';

import sharedTranslations from 'messages/shared';
import translations from 'messages/widget';

import { isLiveVideo } from '@wix/wix-vod-shared/src/common/ui-selectors/video/video-origin';
import ActionsPanel from '@wix/wix-vod-shared/src/widget/vod-player/components/actions-panel/actions-panel';
import AnimatedOverlayContent from './containers/animated-overlay-content/animated-overlay-content';
import Loggers from './containers/loggers/loggers';
import PlayerUIVisibilityManager from '@wix/wix-vod-shared/src/widget/vod-player/components/ui-visibility-manager/ui-visibility-manager';
import videoCardsBiLogger from 'widget/player-widget/components/new-player/bi-loggers/video-cards-bi-logger';

import VIDEO_CARDS_BI_ORIGIN from '@wix/wix-vod-shared/src/common/bi-constants/video-cards-origin';
import INFO_OVERLAY_CONTENT from './containers/animated-overlay-content/info-overlay-content-enums';


@connect(
  (state, ownProps) => {
    const cardsData = getVideoCardsList(state);

    const props = {
      vidiUrls: getVidiUrls(ownProps),
      cardsData,

      canShowAllCards: !_.isEmpty(cardsData),
      areElementsRounded: areElementsRounded(state),

      isPlayerUIVisible: isPlayerUIVisible(state),
      isInFullScreen: isInFullScreen(state),
      isShareOverlayOpen: isShareOverlayOpen(state),

      isLive: isLiveVideo(_.get(ownProps, 'videoItem')),
    };
    return props;
  }, {
    toggleShareVideoOverlay,
    showPlayerUI,
    hidePlayerUI,
    playVideo,
    pauseVideo,
  })
export default class InternalPlayer extends React.Component {

  static propTypes = {
    appSettings: PropTypes.object,
    channelData: PropTypes.object,
    videoItem: PropTypes.object,

    vidiUrls: PropTypes.array,
    className: PropTypes.string,
    mobileMode: PropTypes.bool,
    playAtFullScreen: PropTypes.bool,

    width: PropTypes.number,
    height: PropTypes.number,

    preload: PropTypes.string,

    onPlayRequest: PropTypes.func,
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onEnded: PropTypes.func,

    onError: PropTypes.func,
    onSubscribeRequest: PropTypes.func,
    onPurchaseRequest: PropTypes.func,
    onFullScreenChanged: PropTypes.func,
    onShareRequest: PropTypes.func,
    onVideoInfoShow: PropTypes.func,

    isVideoPlayRequested: PropTypes.bool,
    isVideoPauseRequested: PropTypes.bool,
    isVideoPlaying: PropTypes.bool,
    isVideoPaused: PropTypes.bool,
    isPlayerUIVisible: PropTypes.bool,
    isShareOverlayOpen: PropTypes.bool,
    isLive: PropTypes.bool,
    isInFullScreen: PropTypes.bool,


    cardsData: PropTypes.array,

    // actions panel config
    areElementsRounded: PropTypes.bool,
    canShowFullInfo: PropTypes.bool,
    canShareVideo: PropTypes.bool,
    canShowAllCards: PropTypes.bool,
    canShowTitle: PropTypes.bool,
    canShowBuyRentButton: PropTypes.bool,

    toggleShareVideoOverlay: PropTypes.func,
    showPlayerUI: PropTypes.func,
    hidePlayerUI: PropTypes.func,
    playVideo: PropTypes.func,
    pauseVideo: PropTypes.func,
  };

  static defaultProps = {
    onPlay: _.noop,
    onPause: _.noop,
    onEnded: _.noop,

    onError: _.noop,
    onFullScreenChanged: _.noop,

    onShareRequest: _.noop,
    onVideoInfoShow: _.noop,

    width: 640,
    height: 360,

    preload: 'none',

    onPlayRequest: _.noop,
    canShowTitle: true,
    canShowBuyRentButton: true,
  };

  state = {
    VideoPlayerWrapper: null,
    overlayContent: null,
    VODplayer: null,
    isMuted: false,
  };

  componentDidMount() {
    this.loadPlayerPromise = makeCancelable(loadVODPlayer());
    this.loadPlayerPromise
      .promise
      .then(VODplayerModule => {
        VODplayerModule.Player.DefaultModules.ProgressControl.View.extendStyleNames(progressBarStyles);

        //I know, i know
        const oldEnterFullScreen = VODplayerModule.Player.DefaultModules.FullScreenManager.prototype.enterFullScreen;

        VODplayerModule.Player.DefaultModules.FullScreenManager.prototype.enterFullScreen = function () {
          if (isPreviewOrEditorMode()) {
            openPreviewPrompt();
            return;
          }
          oldEnterFullScreen.call(this);
        };

        this.setState({ VODplayer: VODplayerModule.default });
      });
  }

  componentWillReceiveProps(nextProps) {
    this.shouldCloseOverlay(nextProps);
  }

  componentWillUnmount() {
    this.loadPlayerPromise.cancel();
  }

  shouldCloseOverlay(nextProps) {
    const { videoItem: { id }, isVideoPlaying, isShareOverlayOpen } = nextProps;

    const isPlayStarted = isVideoPlaying && !this.props.isVideoPlaying;
    const isVideoIdChanged = this.props.videoItem.id !== id;
    const hasClosedOverlay = !isShareOverlayOpen && this.props.isShareOverlayOpen;

    if (isPlayStarted || isVideoIdChanged || hasClosedOverlay) {
      this.closeOpenOverlays();
    }
  }

  @autobind
  onEnded(...args) {
    this.closeOpenOverlays();
    this.props.onEnded(args);
  }

  @autobind
  onPlayerInit(player) {
    _.defer(() => {
      this.setState({
        player,
        eventEmitter: player._defaultModules.eventEmitter,
        engine: player._defaultModules.engine,
      });
    });
  }

  getBuyRentButtonText() {
    const { channelData, videoItem } = this.props;
    return getBuyRentTextForPlayer({ channelData, videoItem });
  }

  getVideoOwnershipStatus() {
    const { videoItem } = this.props;
    return getOwnershipStatus(videoItem);
  }

  @autobind
  reportAnomaly() {
    //getNewRelic();
  }

  @autobind
  handleOverlayClose() {
    if (this.state.overlayContent === INFO_OVERLAY_CONTENT.ALL_CARDS) {
      videoCardsBiLogger.logAllCardsCloseButtonClick();
    }

    this.closeOpenOverlays();
  }

  @autobind
  closeOpenOverlays() {
    this.props.showPlayerUI();
    this.setState({ overlayContent: null });
  }

  @autobind
  openShareOverlay() {
    const { toggleShareVideoOverlay, hidePlayerUI } = this.props;
    hidePlayerUI();
    toggleShareVideoOverlay();
  }

  @autobind
  openVideoInfoOverlay() {
    this.props.hidePlayerUI();
    this.setState({
      overlayContent: INFO_OVERLAY_CONTENT.VIDEO_INFO,
    });
  }

  @autobind
  handleAllCardsButtonClick() {
    this.props.hidePlayerUI();
    this.setState({
      overlayContent: INFO_OVERLAY_CONTENT.ALL_CARDS,
    });
    videoCardsBiLogger.logAllCardsButtonClick();
  }

  @autobind
  getBuyClickHandler() {
    const { videoItem, channelData } = this.props;

    return getBuyClickHandler({
      videoItem,
      channelData,
      purchaseFn: this.proxyPurchaseRequest,
      subscribeFn: this.proxySubscribeRequest,
    });
  }

  @autobind
  proxySubscribeRequest() {
    const { onSubscribeRequest } = this.props;
    onSubscribeRequest();
  }

  @autobind
  proxyPurchaseRequest() {
    const { onPurchaseRequest } = this.props;
    onPurchaseRequest();
  }

  onPlayAbort = () => {
    const { pauseVideo, playVideo, videoItem } = this.props;
    pauseVideo(videoItem.id);
    this.setState({ isMuted: true });
    _.defer(() => playVideo(videoItem.id));
  };

  getFullScreenShareOverlay() {
    const { channelData, videoItem, mobileMode, isInFullScreen } = this.props;

    if (mobileMode) {
      return null;
    }

    if (!isInFullScreen) {
      return null;
    }

    return (
      <ShareOverlay key={`share-${videoItem.id}`}
                    channelData={channelData}
                    videoItem={videoItem} />
    );
  }

  getActionButtonLabels() {
    return {
      videoInfoFullText: i18n.t(sharedTranslations.videoInfoFullText),
      videoInfoShortText: i18n.t(sharedTranslations.videoInfoShortText),
      shareVideoFullText: i18n.t(sharedTranslations.shareVideoFullText),
      shareVideoShortText: i18n.t(sharedTranslations.shareVideoShortText),
      showAllCardsFullText: i18n.t(sharedTranslations.showAllCardsFullText),
      showAllCardsShortText: i18n.t(sharedTranslations.showAllCardsShortText),
    };
  }

  getVideoCardsAccessibilityLabels() {
    return {
      facebookButtonTitle: i18n.t(translations.likeThisPageOnFacebook),
      youtubeButtonTitle: i18n.t(translations.subscribeToYoutubeChannel),
      twitterButtonTitle: i18n.t(translations.followOnTwitter),
    };
  }

  render() {
    const {
      // video player config
      mobileMode,
      width,
      height,
      vidiUrls,
      isVideoPlayRequested,
      isVideoPlaying,
      isVideoPaused,
      isVideoPauseRequested,
      isPlayerUIVisible,
      playAtFullScreen,
      onError,
      videoItem,
      channelData,
      onPlay,
      onPause,
      onFullScreenChanged,
      cardsData,
      preload,
      isLive,

      // actions panel config
      areElementsRounded,
      canShowFullInfo,
      canShareVideo,
      canShowAllCards,
      canShowTitle,
      canShowBuyRentButton,

      // animated content config
      onShareRequest,
    } = this.props;

    const { engine, eventEmitter, player, overlayContent, VODplayer } = this.state;

    if (!VODplayer) {
      return <Spinner />;
    }

    const buyRentButtonText = this.getBuyRentButtonText();
    const prevButtonAriaLabel = i18n.t(translations.slideToPrevActionCard);
    const nextButtonAriaLabel = i18n.t(translations.slideToNextActionCard);
    const getSlideAriaLabel = variables => i18n.t(translations.allCardsSlideContents, variables);

    return (
      <VODplayer width={width}
                 height={height}
                 preload={preload}
                 mobileMode={mobileMode}
                 vidiUrls={vidiUrls}
                 videoItem={videoItem}
                 channelData={channelData}
                 isVideoPlayRequested={isVideoPlayRequested}
                 isVideoPauseRequested={isVideoPauseRequested}
                 playAtFullScreen={playAtFullScreen}
                 modules={{ cards: CardsModule }}
                 texts={getPlayerTranslations()}
                 canShowTitle={canShowTitle}
                 onPlay={onPlay}
                 onPause={onPause}
                 onError={onError}
                 muted={this.state.isMuted}
                 onPlayAbort={this.onPlayAbort}
                 onEnded={this.onEnded}
                 onAnomalyDetected={this.reportAnomaly}
                 onFullScreenChanged={onFullScreenChanged}
                 onInit={this.onPlayerInit}>

        {
          !mobileMode && (
            <ActionsPanel videoItem={videoItem}
                          isFocusable={isVideoPlaying || isVideoPaused}
                          areElementsRounded={areElementsRounded}
                          canShowBuyRentButton={canShowBuyRentButton && Boolean(buyRentButtonText)}
                          canShowTitle={canShowTitle}
                          canShowAllCardsButton={canShowAllCards}
                          canShowFullInfo={canShowFullInfo}
                          canShareVideo={canShareVideo}
                          onShareVideoShow={this.openShareOverlay}
                          onBuyRentButtonClick={this.getBuyClickHandler()}
                          onAllCardsButtonClick={this.handleAllCardsButtonClick}
                          videoOwnershipStatus={this.getVideoOwnershipStatus()}
                          onVideoInfoShow={this.openVideoInfoOverlay}
                          buyRentButtonText={buyRentButtonText}
                          {...this.getActionButtonLabels()}
                          infoButtonAriaLabel={i18n.t(translations.showVideoInfo)}
                          shareButtonAriaLabel={i18n.t(translations.share)}
                          allCardsButtonAriaLabel={i18n.t(translations.allCards)} />
          )
        }

        {
          !mobileMode && (
            <AnimatedOverlayContent videoItem={videoItem}
                                    channelData={channelData}
                                    overlayContent={overlayContent}
                                    onShareRequest={onShareRequest}
                                    onClose={this.handleOverlayClose}
                                    allCardsOverlayContent={(
                                      <VideoCardsWrapper thumbnailSize={300}
                                                         biOrigin={VIDEO_CARDS_BI_ORIGIN.ALL_CARDS}
                                                         cardsData={cardsData}>
                                        {
                                          ({ cardsData, onCardClick }) => (
                                            <AllVideoCards cardsData={cardsData}
                                                           onCardClick={onCardClick}
                                                           getSlideAriaLabel={getSlideAriaLabel}
                                                           prevButtonAriaLabel={prevButtonAriaLabel}
                                                           nextButtonAriaLabel={nextButtonAriaLabel}
                                                           labels={this.getVideoCardsAccessibilityLabels()} />
                                          )

                                        }
                                      </VideoCardsWrapper>
                                    )} />
          )
        }

        {
          !mobileMode && player && !player._destroyed && (
            <VideoCardsWrapper cardsData={cardsData}
                               player={player}
                               biOrigin={VIDEO_CARDS_BI_ORIGIN.VIDEO}>
              {
                ({ cardsData, onCardClick }) => (
                  <VideoCards cardsData={cardsData}
                              player={player}
                              onCardClick={onCardClick}
                              labels={this.getVideoCardsAccessibilityLabels()} />
                )
              }
            </VideoCardsWrapper>
          )
        }

        {
          !mobileMode && (
            <PlayerUIVisibilityManager isPlayerUIVisible={isPlayerUIVisible} />
          )
        }

        {
          player && !player._destroyed && (
            <Loggers engine={engine}
                     eventEmitter={eventEmitter}
                     videoItem={videoItem}
                     channelData={channelData}
                     isVideoPlaying={isVideoPlaying}
                     isLive={isLive} />
          )
        }
        {
          player && !player._destroyed && isLive && (
            <LiveVideoUpdaters eventEmitter={eventEmitter}
                               videoItem={videoItem}
                               channelId={channelData.id} />
          )
        }
        {this.getFullScreenShareOverlay()}
      </VODplayer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/player-internal.js